import React, { useCallback, useState } from 'react';
import { ModalButton, ModalContent, ModalForm, ModalInput } from './styles';
import Button from '../../button';
import { renameSnap } from '../../../services/snapService';
import { ScreenRecording } from '../../../mobx/interfaces/app';
import { BUTTON_TYPE } from '../../../global/constants';
import ModalHeader from '../modalHeader';

interface SnapData {
  onClose: () => void;
  loadData: () => void;
  snapData: ScreenRecording;
}

const SnapRenameModal: React.FC<SnapData> = (props) => {
  const { snapData } = props;
  //States
  const [loading, setLoading] = useState(false);
  const fileNameWithoutExtension =
    snapData?.Name && snapData?.Name?.split('.')?.length > 1
      ? snapData?.Name?.split('.')?.slice(0, -1).join('.')
      : snapData?.Name || '';
  const [snapName, setSnapName] = useState(fileNameWithoutExtension);

  const onRenameFile = useCallback(
    async (e: React.SyntheticEvent) => {
      try {
        e.preventDefault();
        setLoading(true);
        const payload = {
          Name: snapName
        };
        await renameSnap(snapData['_id'], payload);
        props?.loadData();
      } catch (error) {
        console?.log('error', error);
      } finally {
        setLoading(false);
        props?.onClose();
      }
    },
    [props, snapData, snapName]
  );

  return (
    <>
      <ModalHeader title='Rename File' onClose={props?.onClose} />
      <ModalContent onSubmit={onRenameFile}>
        <ModalForm>
          <ModalInput
            type='text'
            placeholder='Enter File name'
            value={snapName}
            onChange={(e: { target: { value: string } }) => setSnapName(e.target.value)}></ModalInput>
        </ModalForm>
        <ModalButton>
          <Button variant={BUTTON_TYPE.PRIMARY} buttonType={'submit'} title={'Rename'} isLoading={loading} />
        </ModalButton>
      </ModalContent>
    </>
  );
};

export default SnapRenameModal;
